import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "components/elements/Dialog";

interface IProps {
  children: React.ReactNode;
  handleClose: () => void;
  title: string;
}

export default function ChartModal({ children, handleClose, title }: IProps) {
  return (
    <Dialog open fullWidth={true} maxWidth={"xl"} onClose={handleClose} responsiveWidth={true}>
      <DialogTitle sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        {title}
        <Box flexGrow={1} display="flex" justifyContent="flex-end" alignItems="center">
          <IconButton edge="end" size="small" color="inherit" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ height: `${(window.innerHeight / 4) * 3}px` }}>{children}</DialogContent>
    </Dialog>
  );
}
